import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
    IApproverInterface,
    IReimbursement,
    ISingleReimbursement,
    ReimbursementDataCreateRes,
    ReimbursementInput
} from './interface';

const API_URI = `${environment.apiBaseUrl}/request-form`;
@Injectable({
    providedIn: 'root'
})
export class ReimbursementService {
    http: HttpClient = inject(HttpClient);

    getAllReimbursments(queryParams: { formTitle: string }) {
        return this.http.get<IReimbursement[]>(API_URI, { params: queryParams });
    }

    createReimbursment(input: ReimbursementInput) {
        return this.http.post<ReimbursementDataCreateRes>(
            `${API_URI}/create/reimbursement-data`,
            input
        );
    }

    submitReimbursment(input: { requestFormId: string; initiatorId: string }) {
        return this.http.post<IReimbursement>(`${API_URI}/reimbursement-form/submit`, input);
    }

    getSingleReimbursment(id: string) {
        return this.http.get<ISingleReimbursement>(`${API_URI}/single/${id}`);
    }

    getByUser(input: { id: string; query: string }) {
        return this.http.get<IReimbursement[]>(
            `${API_URI}/user/${input.id}?formTitle=${input.query}`
        );
    }

    getApproverRequests(input: { id: string; query: string }) {
        return this.http.get<IApproverInterface[]>(
            `${API_URI}/assigned-requests/${input.id}?formTitle=${input.query}`
        );
    }

    deleteReimbursment(id: string) {
        return this.http.delete(`${API_URI}/reimbursement-data/${id}`);
    }
    deleteReq(id: string) {
        return this.http.delete(`${API_URI}/${id}`);
    }
}
